module.exports = __webpack_public_path__ + "img/seconds.0bc6bf49.svg";